/**
 * SFTP Service Switch
 * Uses mock data when VITE_ENABLE_MOCK_DATA is true, otherwise real API.
 */
import config from '../config/config';

import * as realService from './sftpService';
import * as mockService from './mockSftpService';

const svc = config.features.enableMockData ? mockService : realService;

export const getSftpSites = svc.getSftpSites;
export const getAllSftpSites = svc.getAllSftpSites;
export const getSftpSiteById = svc.getSftpSiteById;
export const createSftpSite = svc.createSftpSite;
export const updateSftpSite = svc.updateSftpSite;
export const deleteSftpSite = svc.deleteSftpSite;
export const browseSftpFiles = svc.browseSftpFiles;
